import React from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import { CrateItem } from "../utils";

interface CrateItemCardProps {
  item: CrateItem;
}

const CrateItemCard: React.FC<CrateItemCardProps> = ({ item }) => {
  return (
    <View>
      <View style={styles.card}>
        <View style={styles.contentContainer}>
          <Text variant="body_text_3">{item.name}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    borderRadius: 12,
    paddingVertical: 16,
    paddingHorizontal: 6,
    borderBottomColor: color.borderColor2,
    borderBottomWidth: 1,
  },
  contentContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export default CrateItemCard;
